export default __webpack_public_path__ + "static/media/ebc-logo.0eafe6ad.png";